import {supportedLngs} from './i18n';
import webUtils from './webUtils';
import i18n from "i18next";

const pathUtils = {
  isEyewear: () => !!window.location.pathname.match('eye-wear'),
  getPFSiteURL: (pathname, language) => pathUtils.replaceUrlLang(language, pathname),
  getConsoleURL: () => (webUtils.isMakeupARSite() ? process.env.REACT_APP_CONSOLE_URL_MAKEUPAR : process.env.REACT_APP_CONSOLE_URL),
  convertToLangPrefix: (language = '') => {
    if (['en'].includes(language)) {
      return '';
    }
    if (supportedLngs.includes(language)) {
      return language;
    }
    return '';
  },
  getAllLangPrefixes: () => supportedLngs.map((lng) => pathUtils.convertToLangPrefix(lng)),
  getLangFromPathname: (pathname = '') => {
    const language = pathname.split('/')[1];
    return supportedLngs.includes(language) ? language : 'en';
  },
  replaceUrlLang: (newLang = 'en', pathname = '', search = '') => {
    const oldLangPrefix = pathUtils.convertToLangPrefix(pathUtils.getLangFromPathname(pathname));
    const langPrefixRemoved = oldLangPrefix ? pathname.replace(`/${oldLangPrefix}`, '') : pathname;
    const trimmedPathname = langPrefixRemoved.replace(/^(\/)?|(\/)?$/g, '');

    const newLangPrefix = pathUtils.convertToLangPrefix(newLang);
    if (!newLangPrefix) {
      return `/${trimmedPathname}${search}`;
    }
    return trimmedPathname ? `/${newLangPrefix}/${trimmedPathname}${search}` : `/${newLangPrefix}${search}`;
  },
  langToPathPrefix: () => (i18n.language === 'en' || !i18n.language ? '' : `/${i18n.language.replace('_', '-').toLowerCase()}`),
};

export default pathUtils;
